import { render, staticRenderFns } from "./Activity10.vue?vue&type=template&id=6fd975bc&scoped=true"
import script from "./Activity10.vue?vue&type=script&lang=js"
export * from "./Activity10.vue?vue&type=script&lang=js"
import style0 from "./Activity10.vue?vue&type=style&index=0&id=6fd975bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd975bc",
  null
  
)

export default component.exports